import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Transportista/cambioEstadoSeleccionTransporte`, method: 'POST', body: {list}, token: token})
}